export const enumsState = {
  allEnums: [],
};
